import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
  flex: 1;
  height: fit-content;
  min-height: 100vh;

  padding: 36px;
`;

export const InputsFilterWrapper = styled.form`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  width: 100%;
  height: fit-content;

  > div {
    flex: 1;
  }
`;

export const TotalsInfoCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 28px;
  width: 100%;
`;

export const ChartsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  width: 100%;

  > div {
    min-width: 48%;
  }

  > div:nth-child(6) {
    min-width: 100%;
    width: 100%;
    height: 368px;
  }
  > div:nth-child(5),
  div:nth-child(6) {
    height: 440px;
  }
`;
